module.exports = __webpack_public_path__ + "media/images/reseller-cover-8a26c132.png";